export const envVars: object = {
  "rollbarAccessToken": "4aac1695f6314bfaa4dd282461e2f464"
};